import React from 'react';
import { DEFAULT_MAX_TEXT_LENGTH } from '#shared/constants/common';
import { sliceTextAddEllipsis } from '#shared/utils/sliceTextAddEllipsis';
import styled from 'styled-components';
import { colors } from '../../../themes/lightTheme';

const StyledComponentCustomLink = styled.div`
  flex: none;
  order: 0;
  flex-grow: 0;
  color: ${colors.primary600};
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
`;

const CrumbLink = ({ handler, label }) => {
  return (
    <div onClick={handler}>
      <StyledComponentCustomLink>
        {sliceTextAddEllipsis(label, DEFAULT_MAX_TEXT_LENGTH)}
      </StyledComponentCustomLink>
    </div>
  );
};

export default CrumbLink;
